// userService.js
import { get, post, patch } from './common';


export const inviteeList = (filterData, headers ) => {
    return get('invite/list', filterData, headers);
};

export const resendInvite = (data) => {
  return post('invite/resend-invite-otp', data);
};

export const updateInviteeStatus = (data, userId) => {
  return patch('invite/update-status/'+userId, data);
};

export const inviteUsers = (data) => {
  return post('invite', data);
};


  